
export const navbar = {
  'backoffice.navbar.notifications': 'Notificaciones',
  'backoffice.navbar.language': 'Idioma',
  'backoffice.navbar.signIn': 'Iniciar sesión'
};
